import styled from 'styled-components'

export default styled.div`
// CTA
.inner {
    .skewed-secondary {
        .secondary {
            align-items: center;
            text-align: center;
            @media (min-width: ${props => props.theme.breakpoints.desktop}) {
                align-items: stretch;
                text-align: left;
            }
        }
    }
}
`